import React, { useState } from 'react';
import dayjs from 'dayjs';
import { useAppSelector } from '../../hooks/redux';
import { useDateRange } from '../../hooks/useDateRange';
import SalesDetailByCashRegister from './cashMovements/SalesDetailByCashRegister';
import WithdrawalBreakdown from './cashMovements/WithdrawalBreakdown';
import ShiftSummary from './cashMovements/ShiftSummary';
import CashFlowAnalysis from './cashMovements/CashFlowAnalysis';
import DiscrepancyAnalysis from './cashMovements/DiscrepancyAnalysis';

interface CashMovementsReportProps {
  selectedPeriod: string;
  customDateRange?: [dayjs.Dayjs, dayjs.Dayjs] | null;
}

const VIEWS = [
  { key: 'salesDetail', label: 'Ventas por caja' },
  { key: 'withdrawals', label: 'Retiros e ingresos' },
  { key: 'shifts', label: 'Turnos' },
  { key: 'cashflow', label: 'Flujo de efectivo' },
  { key: 'discrepancies', label: 'Diferencias' },
] as const;

type ViewKey = (typeof VIEWS)[number]['key'];

/**
 * The five cash views as pills instead of a second layer of AntD tabs —
 * this component already renders inside the page's tab bar, and nested
 * identical tab bars read as one navigation level too many.
 */
const CashMovementsReport: React.FC<CashMovementsReportProps> = ({
  selectedPeriod,
  customDateRange,
}) => {
  const { currentRestaurant } = useAppSelector((state) => state.restaurant);
  const dateRange = useDateRange(selectedPeriod, customDateRange);
  const [activeView, setActiveView] = useState<ViewKey>('salesDetail');

  const restaurantId = currentRestaurant?.id || '';
  const { fromDate, toDate } = dateRange;

  const childProps = { restaurantId, fromDate, toDate, selectedPeriod, customDateRange };

  return (
    <div>
      <div className="rep-subpills">
        {VIEWS.map((view) => (
          <button
            key={view.key}
            type="button"
            className={`rep-subpill${activeView === view.key ? ' rep-subpill--selected' : ''}`}
            onClick={() => setActiveView(view.key)}
          >
            {view.label}
          </button>
        ))}
      </div>

      {activeView === 'salesDetail' && <SalesDetailByCashRegister {...childProps} />}
      {activeView === 'withdrawals' && <WithdrawalBreakdown {...childProps} />}
      {activeView === 'shifts' && <ShiftSummary {...childProps} />}
      {activeView === 'cashflow' && <CashFlowAnalysis {...childProps} />}
      {activeView === 'discrepancies' && <DiscrepancyAnalysis {...childProps} />}
    </div>
  );
};

export default CashMovementsReport;
